import React, { ReactNode } from "react";
import BoxComponent from "../Box/BoxComponent";
import { IconButton } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import { ItemDestaque } from "../../pages/Cardapio/public/CatalogoPage";

interface CarouselProps {
    itens?: ItemDestaque[];
    children: ReactNode
}

const CarouselComponent = (props: CarouselProps) => {
    return <BoxComponent
        component="div"
        sx={{
            position: "relative"
        }}
    >
        <IconButton
            className="prev"
            sx={{
                position: "absolute",
                left: 10,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 10,
                backgroundColor: "#fff",
                borderColor: "#f3f4f3",
                width: 25,
                height: 25
            }}
        >
            {`<`}
        </IconButton>

        <IconButton
            className="next"
            sx={{
                position: "absolute",
                right: 10,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 10,
                backgroundColor: "#fff",
                borderColor: "#f3f4f3",
                width: 25,
                height: 25
            }}
        >
             {`>`}
        </IconButton>

        <Swiper
            modules={[Navigation]}
            navigation={{
                prevEl: ".prev",
                nextEl: ".next",
            }}
            centeredSlides={false}
            spaceBetween={20}
            slidesPerView={"auto"}
            style={{
                //overflow: "visible",
                width: "100%",

            }}
            // slidesPerGroup={2}
        >
            {React.Children.map(props.children, (child, index) => (
                <SwiperSlide
                    key={index}
                    style={{ width: "auto" }} // importante pro slidesPerView="auto"
                >
                    {child}
                </SwiperSlide>
            ))}
        </Swiper>
    </BoxComponent>
}

export default CarouselComponent;